import { Link } from "react-router-dom";
import type { ContentDiscussion } from "@/types/content";
import StanceTag from "./StanceTag";
import { formatCount } from "./TopicCard";

const avatarPalette = [
  "bg-primary-100 text-primary-800",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-900",
];

function avatarClass(name: string) {
  const sum = Array.from(name).reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return avatarPalette[sum % avatarPalette.length];
}

export default function DiscussionCard({ item }: { item: ContentDiscussion }) {
  return (
    <article className="reveal rounded-lg bg-background-50 border border-background-200/80 hover:border-accent-300 transition-colors duration-300 p-4 md:p-5">
      <div className="flex items-start gap-3">
        <span
          className={`shrink-0 w-10 h-10 flex items-center justify-center rounded-full text-sm font-medium ${avatarClass(
            item.author
          )}`}
          aria-hidden="true"
        >
          {item.author.slice(0, 1)}
        </span>

        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
            <span className="text-sm font-medium text-foreground-900">{item.author}</span>
            <StanceTag stance={item.stance} />
            <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
          </div>

          <p className="mt-3 text-sm leading-relaxed text-foreground-700">{item.content}</p>

          {item.badges.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-2">
              {item.badges.map((badge) => (
                <span
                  key={badge}
                  className="px-2 py-0.5 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-600"
                >
                  {badge}
                </span>
              ))}
            </div>
          )}

          <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1 whitespace-nowrap">
              <i className="ri-thumb-up-line text-accent-600 w-4 h-4 flex items-center justify-center" />
              {formatCount(item.likes)} 赞
            </span>
            <span className="inline-flex items-center gap-1 whitespace-nowrap">
              <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center" />
              {item.replies} 回复
            </span>
            <Link
              to={`/topic/${item.topicId}`}
              className="inline-flex items-center gap-1 text-primary-700 hover:text-primary-800 transition-colors truncate max-w-full"
            >
              <i className="ri-links-line w-4 h-4 flex items-center justify-center shrink-0" />
              <span className="truncate">{item.topicTitle}</span>
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}